import { useGetStoresQuery } from 'src/features/store/api/storeApi';
import { DataDTOStoreListing } from 'src/types/api/generated/api';
import { getSelectedClientId } from 'src/utils/client';

export const useStores = (): { stores: DataDTOStoreListing[]; isFetchingStores: boolean } => {
  const clientId = getSelectedClientId();
  const { data, isFetching } = useGetStoresQuery(
    { page: 0, pageSize: 0, orderBy: 'name ASC', clientId },
    { skip: !clientId },
  );

  return { stores: data?.rows ?? [], isFetchingStores: isFetching };
};
